@if (shouldShow) {
    <ms-epcot-notification [notificationType]="'info'" [showCloseButton]="true" (closeButtonClick)="onCloseButtonClick()">
        <section message>
            <span>{{ messageText }}</span>
            @if (linkText) {
                <a class="btn btn-link" (click)="onLinkClick()">{{ linkText }}</a>
            }
        </section>
    </ms-epcot-notification>
}
